import React, { useState } from "react";
import NavBarLeft from "../../ReusableComp/NavBarLeft";
import NavigationBar from "../../ReusableComp/NavigationBar";
import Select from "../../ReusableComp/Select";
import { Col, Container, Row, Stack, Table } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  
  getSubjProfDetails,
  getAllCausalities,
  getAllOutComes,
  getActionTaken,
  getActionTakenForAE,
  resetAEStepperData,
  resetSubjectProfile,
  getPmsStudyData,
  getNewPmsStudyData,
  getPmsSubjectDtls,
  getPmsEventSubjectList,
  getPmsAdvEventOfSubject,
  getPmsEventComments,
  getPmsNotifications
} from "../../../Redux/actions/actions";
import {
  SUBJECT_STATUS_OFF_STUDY,
  SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT,
  SUBJECT_STATUS_ON_STUDY,
  EVENT_STATUS_REVIEWED,
  MEDICAL_REVIEWER,
  PRINCIPAL_INVESTIGATOR,
  EVENT_CLASSIFICATION_AESI,
  EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
  EVENT_CLASSIFICATION_GRADE_CTCAE,
  EVENT_CLASSIFICATION_OTHER,
  QUALITY_REVIEWER,
  base_url,
  PMS_ADMIN
} from "../../../utilities";
import moment from "moment";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { formatDate } from "../../ReusableComp/dateFormat";
import { Modal } from 'react-bootstrap';
import { MeddraForm, WhoDDForm } from "../../Quality_Reviewer/ReviewList";
import Loader from '../../ReusableComp/Loader';

const PISubjectsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const subjectList = useSelector((state) => state.pmsSubjectList);
  const subjectCounts = useSelector((state) => state.pmsSubjeCtDashboardcounts);
  const reviewerComments = useSelector((state) => state.eventPmsComment);
  const subjDetails = useSelector((state) => state.subjPmsDtls);
  const eventDtls = useSelector((state) => state.eventPmsDtls);
  const whoddList = useSelector((state) => state.whoddList);
  const studyName=localStorage.getItem('study_name')
 
  const getEventFlag = useSelector((state) => state.getEventFlag);

  const [selectedMedraId, setSelectedMedraId] = useState("");
  const [medraSelected, setIsMedraSelected] = useState(false);
  const [whoddSelected, setIsWhoddSelected] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const aeSubject = useSelector((state) => state.pmsAdverseEvent);
  const subjectProfile = useSelector((state) => state.subjPmsDtls);
  const [currentPage, setCurrentPage] = useState(
    location.state == undefined || location.state == null
      ? 1
      : location.state.data
  );
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [doseOptions, setDoseOptions] = useState(null);
  const [statusOptions, setStatusOptions] = useState(null);
  const [siteOptions, setSiteOptions]=useState(null);
  const [doseSelected, setDoseSelected] = useState("");
  const [statusSelected, setStatusSelected] = useState("");
  const [siteSelected, setSiteSelected]=useState("");
  const [subjProfData, setSubjProfData] = useState({});
  let [loading_flag, setLoading_flag] = useState(false);
  const [loading, setLoadingg] = useState(false);
  const [whoDDClassification, setWhoDDClassification] = useState();
  const [selectedDocument, setSelectedDocument] = useState(null);
  const JustBtwn = "d-flex justify-content-between";
  const [flag, setFlag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  let extensions=""
 

  useEffect(() => {
    setLoading_flag(true)     
    dispatch(getPmsStudyData())
    dispatch(getNewPmsStudyData())

    if (eventDtls?.action_taken_for_adverse_event_name !== "None") {
      setFlag(true);
    }
    else {
      setFlag(false)
    } 
    if(getEventFlag ===null){
       
      setLoading_flag(true)
      setSelectedOption("all_events")
      setFilteredData(subjectList)}
      setTimeout(() => {
        setLoading_flag(false)
        
      }, 500);
    if(subjectList){
      if (selectedOption === 'serious_adverse_events') {
        setFilteredData(subjectList.filter(i => i.sae_count>0))
      } else if (selectedOption === 'adverse_events') {
        setFilteredData(subjectList.filter(i => i.ae_count>0))
      } else if(selectedOption === 'subject_with_adverse_events'){
        setFilteredData(subjectList.filter(i => i.ae_count>0))
      }else if (selectedOption === 'all_events') {
        setFilteredData(subjectList)
      }else{
        setFilteredData(subjectList)
        setSelectedOption("all_events")
      }
    }  
    if (!localStorage.getItem("login_user_name")) {
      navigate("/");
    }
    disableBackButton();
    // setLoading_flag(false);

  }, [dispatch, localStorage.pi_id,localStorage.study_id,subjectList !== null,eventDtls]);

  useEffect(() => {
    if (subjectList) {
      setFilteredData(subjectList)
    }
  },[subjectList])
  
  useEffect(() => {
    if (subjectProfile) {
      setLoading_flag(false)
    }
  },[subjectProfile])

  useEffect(()=>{
    // if(selectedOption!=="all_events"){
      handleRadioChange(selectedOption)
    // }
  },[subjectList])
  

  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }


  function exportToExcel() {
    let excelArray = [];
    filteredData.forEach((i) => {
      const today = new Date();
      const birthDate = new Date(i.date_of_birth);
      let calculatedAge = today.getFullYear() - birthDate.getFullYear();

      if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        calculatedAge--;
      }

      switch (i.status) {
        case SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT:
          i.status = "On Going Adverse Event";
          break;
        case SUBJECT_STATUS_ON_STUDY:
          i.status = "On Study";
          break;
        case SUBJECT_STATUS_OFF_STUDY:
          i.status = "Off Study";
          break;

        default:
          break;
      }

      let xl_object = {
        "Subject ID": i.subject_code,
        // "Phone Number": i.phone_number,
        // "First Name": i.first_name,
        // "Last Name": i.last_name,
        "Last Updated": moment(i.updatedAt).format("DD-MMM-YYYY hh:mm a"),
        Age: `${calculatedAge} Yrs`,
        Dose: i.dose,
        Sex: i.sex,
        "No.of Events": i.sae_count,
        Status: i.status,
      };
      excelArray.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = excelArray;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Subjects_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const [myArray, setMyArray] = useState([]);
  useEffect(() => {
    if(location.state !== null ){
      handleSubjectData(location.state?.data);
      
      navigate({ state: null });
    }
    const dateOfReport = aeSubject && aeSubject?.date_of_administration;

    if (subjectProfile !== null) {
      setSubjProfData({
        subject_dose_id:
          subjectProfile && subjectProfile["SubjectDoses.subject_dose_id"],
        subject_id: subjectProfile.subject_id,
        study_id: subjectProfile.study_id,
        date_of_administration: dateOfReport,
      });
      let status = `${subjectProfile['SubjectDoses.status']}`
      setMyArray([
        {
          id: 1,
          title: subjectProfile["Study.study_name"],
          description: "Study",
        },
        {
          id: 2,
          title: `D${subjectProfile["SubjectDoses.dose"]}`,
          description: "Dose",
        },
        {
          id: 3,
          title: `${subjectProfile["PrincipalInvestigator.name"]}`,
          description: "Principal Investigator",
        },
        {
          id: 4,
          description: "Status",
          title:
            status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT
              ? "On going adverse event"
              : status == SUBJECT_STATUS_ON_STUDY
              ? "On study"
              : status == SUBJECT_STATUS_OFF_STUDY
              ? "Concluded study"
              : "",
        },
      ]);
    }
  }, [dispatch, subjectProfile]);

  useEffect(() => {
    if (subjectList?.length > 0) {
      const uniqueDoses = Array.from(
        new Set(subjectList.map((json) => json.dose))
      ).filter(Boolean);
      const optionsList = uniqueDoses.map((dose) => ({
        label: dose,
        value: dose,
      }));
      setDoseOptions(optionsList);

      const uniqueStatus = Array.from(
        new Set(subjectList?.map((json) => json.status))
      ).filter(Boolean);
      const optionsStatusList = uniqueStatus?.map((val) => ({
        label: val,
        value: val,
      }));
      setStatusOptions(optionsStatusList);

      const uniqueSites = Array.from(new Set(subjectList?.map(json => json.site_name))).filter(Boolean);
        const optionsSitesList = uniqueSites?.map((val) => ({
            label: val,
            value: val
        }));
        setSiteOptions(optionsSitesList);
    }
  }, [subjectList]);
  const dateOfReport = aeSubject?.date_of_administration;
  const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
  const stepperData = [];
  const afterFollowUpStepperData = [];
  const date = new Date(dateOfReport);
  const startDate = new Date(dateOfReport);
  while (date <= new Date(lastDayActiveFollowUp)) {
    stepperData.push({
      day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`,
      dateOfevent: date.toISOString().split("T")[0],
    });
    date.setDate(date.getDate() + 1);
  }
  const events = aeSubject?.events;

  var i = 0;
  if (events) {
    while (i < Object.keys(events).length) {
      const eventDate = stepperData.filter(
        (date) =>
          date.dateOfevent == Object.keys(events)[i].toString().split("T")[0]
      );
      if (eventDate.length == 0) {
        const test = (Object.keys(events)[i]).toString().split("T")[0]
        const date = new Date(test)
        afterFollowUpStepperData.push({
          day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`,
          dateOfevent: Object.keys(events)[i].toString().split("T")[0],
        });
      }
      i = i + 1;
    }
  }


  const modifiedData1 = stepperData.map((day) => {
    const eventDate = Object.keys(events).find(
      (date) => date === day.dateOfevent
    );
    if (eventDate) {
      return {
        ...day,
        eventClassification: [events[eventDate]],
      };
    }
    return day;
  });

  const modifiedData2 = afterFollowUpStepperData?.map((event) => {
    return {
      ...event,
      eventClassification: [events[event.dateOfevent]],
    };
  });


 
  const modifiedData =
    modifiedData2?.length > 0
      ? [...modifiedData1, ...modifiedData2]
      : [...modifiedData1];

      const sum = filteredData?.reduce((i, currentValue) => {
        return i + currentValue.ae_count;
      }, 0);

      const sum_sae = filteredData?.reduce((i, currentValue) => {
        return i + currentValue.sae_count;
      }, 0);

  const dashboardCards = [
    {
      count: subjectCounts?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
      id: "all_events"
    },
    {
      count: subjectList?.filter(i => i.ae_count>0)?.length,
      image: "./images/icons/subjects_black.svg",
      desc: "Subjects With Adverse Events",
      bgcolor: "#FFFFFF",
      color: "black",
      descolor: "#868686",
      id:"subject_with_adverse_events"
    },
    {
      count: subjectCounts?.aesCount,
      image: "./images/icons/smiley.svg",
      desc: "Adverse Events",
      bgcolor: "rgb(234, 158, 79)",
      color: "#fff",
      descolor: "#fff",
      id:"adverse_events"
    },
    
    {
      count: sum_sae,
      image: "./images/icons/exclamatory.svg",
      desc: "Serious Adverse Events",
      bgcolor: "#D14141",
      id:"serious_adverse_events"
    },
  ];


  const handleSearchData = (event) => {
    const searchText = event.target.value.toLowerCase();
    setSearchText(searchText);
    const filteredData = subjectList?.filter((item) => {
      const phnNum = item.phone_number;
      const subj_id = item.subject_code;
      return (
        subj_id.toLowerCase().includes(searchText) ||
        String(phnNum).includes(searchText)
      );
    });
    setFilteredData(filteredData);
  };

  // const [subjData, setSubjData] = useState([])
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [isBtn, setIsBtn] = useState(false);
  const [array, setArray] = useState([]);

  const handleSubjectData = (data) => {
    setLoading_flag(true)
    setStudyDropdwn(true);
    let subjectId = data?.subject_id;
    
    let dose = parseInt(data?.dose?.match(/\d+/)[0]);
    setCurrentPage(2);
    // setSubjData(data)
    if (subjectId) {
      setLoading_flag(true);
      dispatch(getPmsAdvEventOfSubject(subjectId, dose));
      dispatch(getPmsSubjectDtls({ subject_id: subjectId, dose: dose }));
    }else{
      setLoading_flag(false)
    }
  };

  function handlePageandStudy() {
    setLoading_flag(false);
    dispatch(resetAEStepperData());
    dispatch(resetSubjectProfile());
    setStudyDropdwn(false);
    setCurrentPage(1);
  }



  const handleClearFilters = () => {
    setDoseSelected("");
    setStatusSelected("");
    setSiteSelected("");
    setFilteredData(subjectList);
  };

  const handleAE = (adverse_event_mapping_id) => {
    let obj = {
      subject_id: subjectProfile.subject_id,
      dose: subjectProfile["SubjectDoses.dose"],
    };
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
      user_persona: PMS_ADMIN
    }))
    dispatch(getAllOutComes());
    dispatch(getActionTaken());
    dispatch(getAllCausalities());
    dispatch(getActionTakenForAE());
    dispatch(getSubjProfDetails(obj));
    dispatch(getPmsEventSubjectList(adverse_event_mapping_id));
    dispatch(
      getPmsEventComments({
        adverse_event_mapping_id: adverse_event_mapping_id,
      })
    );
    navigate(setCurrentPage(3), {
      state: {
        adverse_event_mapping_id: adverse_event_mapping_id,
      },
    });
  };
    const handleOptionSelectSite = (e) => {
      let val = e.target.value;
      if (val === 'Sites') {
          val = "";
      }
      setSiteSelected(val)
      const filteredData = subjectList?.filter((item) => {
          // Convert relevant properties to lowercase for case-insensitive search
          const { dose, status,site_name } = item;

          const formattedSubjectCode = dose;
          const formattedPhoneNumber = status;
          const formattedSiteName  = site_name ? site_name : "";
          // Check if subject_id or subject_code contains the search text
          return (
              formattedSubjectCode?.includes(doseSelected) &&
              formattedPhoneNumber?.includes(statusSelected) &&
              formattedSiteName?.includes(val)
          );
      });
      // Update the table or do whatever you want with the filteredData
      setFilteredData(filteredData);

  }
  const handleOptionSelectDose = (e) => {
    let val = e.target.value;
    if (val === "Doses") {
      val = "";
    }
    setDoseSelected(val);
    const filteredData = subjectList.filter((item) => {
      // Convert relevant properties to lowercase for case-insensitive search
      const { dose, status, site_name } = item;

      const formattedSubjectCode = dose;
      const formattedPhoneNumber = status;
      const formattedSiteName  = site_name ? site_name : "";
      // Check if subject_id or subject_code contains the search text
      return (
        formattedSubjectCode?.includes(val) &&
        formattedPhoneNumber?.includes(statusSelected) &&
        formattedSiteName?.includes(siteSelected)
      );
    });
    // Update the table or do whatever you want with the filteredData
    setFilteredData(filteredData);
  };

  const handleOptionSelectStatus = (e) => {
    let val = e.target.value;
    if (val === "Status") {
      val = "";
    }

    setStatusSelected(val);
    const filteredData = subjectList?.filter((item) => {
      const { dose, status,site_name} = item;

      const formattedSubjectCode = dose;
      const formattedPhoneNumber = status;
      const formattedSiteName  = site_name ? site_name : "";
      return (
        formattedSubjectCode?.includes(doseSelected) &&
        formattedPhoneNumber?.includes(val) && 
        formattedSiteName?.includes(siteSelected)

      );
    });
    setFilteredData(filteredData);
  };
  const [studyOption, setStudyOption] = useState();

  const handleOptionChange = (e, key, value) => {
    setStudyOption(value);
  };
 

  const [medicationDetails, setMedicationDetails] = useState([
    {
      ATC: "",
      Product: "",
      searchTerm: "",
      current_idx: 1,
      whoddArray: [],
    },
  ]);
  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const [open, setOpen] = React.useState(false);

  const [subjData, setSubjData] = useState([]);
  //   const [studyDropdwn, setStudyDropdwn] = useState(false);
  //   const [studyOption, setStudyOption] = useState();
  const [inputValue, setInputValue] = useState();
  const [inputValue1, setInputValue1] = useState("");

  const [medraClassBlock, setMedraClassBlock] = useState({
    llt: "",
    pt: "",
    hlt: "",
    hlgt: "",
    soc: "",
  });

  const handleMeddraClassification1 = (event) => {
    if (event.target.value == "") {
      setInputValue({ llt: "", pt: "", soc: "", hlgt: "", hlt: "" });
      setIsMedraSelected(false);
      setSelectedMedraId("");
    }
    setValue(event.target.value);
  };

  const onEncode1 = (searchTerm, object) => {
    setValue1(searchTerm);
    const whoddArray = whoddList?.filter(
      (item) =>
        item.generic_name.toLowerCase() === searchTerm ||
        item.product_name.toLowerCase() === searchTerm
    );

    setArray(whoddArray);
    medicationDetails.map((data, index) => {
      if (data.searchTerm != "" || null) {
        setIsBtn(true);
      } else {
        setIsBtn(false);
      }
      if (data.current_idx == object.current_idx) {
        medicationDetails[index].whoddArray = whoddArray;
        setMedicationDetails(medicationDetails);
      }
    });
  };

  const handleCheckboxChange = (event, checkboxId) => {
    if (event.target.checked) {
      setSelectedCheckboxes((prevSelectedCheckboxes) => [
        ...prevSelectedCheckboxes,
        checkboxId.whodd_classification_master_id,
      ]);
    } else {
      setSelectedCheckboxes((prevSelectedCheckboxes) =>
        prevSelectedCheckboxes.filter(
          (id) => id !== checkboxId.whodd_classification_master_id
        )
      );
    }
  };

 
 
  const onSearch = (searchTerm) => {
    setValue(searchTerm);
  };

  const handleDelete = (event) => {
    let updatedData = [...whoDDClassification];

    updatedData?.map((elemObj, i) => {
      if (elemObj.whodd_classification_master_id === event) {
        updatedData.splice(i, 1);
      }
    });
    setWhoDDClassification(updatedData);

    setSelectedCheckboxes((prevSelectedCheckboxes) =>
      prevSelectedCheckboxes.filter((id) => id !== event)
    );
  };


  const [encodeBtn, setEncodeBtn] = useState(true);
  const onSearch1 = (searchTerm, index) => {
    setValue1(searchTerm);
    setEncodeBtn(false);
    medicationDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = searchTerm;
        setMedicationDetails(medicationDetails);
      }
    });
  };

  const handleDeleteFields = (index) => {
    let updatedData = [...medicationDetails];

    updatedData?.map((elemObj, i) => {
      if (elemObj.current_idx == index) {
        updatedData.splice(i, 1);
      }
    });
    setMedicationDetails(updatedData);
  };

  useEffect(() => {
    if (eventDtls) {
      setInputValue(eventDtls.meddraObject);
      setValue(eventDtls.meddraObject.llt);
      setSelectedMedraId(
        eventDtls.meddraObject.meddra_classification_master_id
      );
      setIsMedraSelected(true);

      eventDtls.whoddDrugs?.map((item) =>
        setSelectedCheckboxes((prevSelectedCheckboxes) => [
          ...prevSelectedCheckboxes,
          item.whodd_classification_master_id,
        ])
      );
      setWhoDDClassification(eventDtls.whoddDrugs);
    }

    if (eventDtls) {
      whoddList?.map((item, i) => {
        if (
          item.whodd_classification_master_id ===
          eventDtls.whodd_classification_master_id
        ) {
          setValue1(item.generic_name);
          setInputValue1(item);
          setIsWhoddSelected(true);
        }
      });
    }
  }, [eventDtls?.adverse_event_mapping_id, eventDtls]);
  function handleMedraClass(e) {
    const { name, value } = e.target;

    setMedraClassBlock((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const cleanText =
    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI
      ? eventDtls?.input_notes_aesi_others
      : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON
      ? eventDtls.study_event_meets_case_definition ||
        eventDtls.study_event_doesnt_meets_case_definition
      : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE
      ? eventDtls.study_ctcae_definition
      : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER
      ? eventDtls?.input_notes_aesi_others
      : "";


      const handleViewClick = (document) => {
        setSelectedDocument(document);
      };
    
      function calculateBMI(weight, height) {
        if (isNaN(weight) || isNaN(height)|| height === null) {
            return "0"; // Display "N/A" if either weight or height is not a number
        }
        const bmi = weight / ((height / 100) ** 2);
    
        return bmi.toFixed(1);
    }


    const handleAscending = () => {
      setAsC(true);
      setDesc(false);
    
      const sortedData = [...filteredData];  
      sortedData.sort((a, b) => {
        const subjectCodeA = a.subject_code;
        const subjectCodeB = b.subject_code;
        return subjectCodeA.localeCompare(subjectCodeB);
      });
      setFilteredData(sortedData);
    };
    
    const handleDescending = () => {
      setDesc(true);
      setAsC(false);
    
      const sortedData = [...filteredData];
    
      sortedData.sort((a, b) => {
        const subjectCodeA = a.subject_code;
        const subjectCodeB = b.subject_code;
        return subjectCodeB.localeCompare(subjectCodeA);
      });
    
      setFilteredData(sortedData);
    };

      const getStatusTextColor = (status) => {
        switch (status) {
          case 'ON STUDY':
            return 'black';
          case 'CONCLUDED STUDY':
            return 'green';
          case 'ON GOING ADVERSE EVENT':
            return 'red';
          default:
            return ''; 
        }
      };

      function getIcon(fileExtension) {
        switch (fileExtension) {
          case 'pdf':
            return "./images/icons/reshot-icon-pdf.svg"
          case 'ppt':
            return "./images/icons/reshot-icon-ppt.svg"
          case 'txt':
            return "./images/icons/reshot-icon-txt.svg"
          case 'docx':
            return "./images/icons/reshot-icon-docx.svg"
          case 'doc':
            return "./images/icons/reshot-icon-doc.svg"
          case 'xls':
            return "./images/icons/reshot-icon-xls.svg"
          case 'csv':
            return "./images/icons/reshot-icon-csv.svg"
          case 'jpg':
            return "./images/icons/reshot-icon-jpg.svg"
          case 'png':
            return "./images/icons/reshot-icon-png.svg"
          case 'jpeg':
            return "./images/icons/reshot-icon-jpeg.svg"
         }
      }
      const handleOpenModal = (document) => {
        setSelectedDocument(document);
      };
      let rolecode = localStorage.getItem('role_code')
      const handleCloseModal = () => {
        setSelectedDocument(null);
      };
      const isImage = (url) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        return imageExtensions.includes(url);
      };

      const [selectedOption, setSelectedOption] = useState(getEventFlag?.option);  

 

      
      useEffect(() => {
      if(getEventFlag?.option ==="serious_adverse_events"){
        setFilteredData(subjectList.filter(i => i.sae_count>0))
      }
      if(getEventFlag?.option ==="adverse_events"){
        setFilteredData(subjectList.filter(i => i.ae_count>0))
      }
      }, [])
      
      
      
            const handleRadioChange = (selectedValue) => {
              setSelectedOption(selectedValue);
              if (selectedValue === 'serious_adverse_events') {
                setFilteredData(subjectList.filter(i => i.sae_count>0))
              } else if (selectedValue === 'adverse_events') {
                setFilteredData(subjectList.filter(i => i.ae_count>0))
              } else if(selectedValue === 'subject_with_adverse_events'){
                setFilteredData(subjectList.filter(i => i.ae_count>0))
              }else if (selectedValue === 'all_events') {
                setFilteredData(subjectList)
              }
            };

      const handleDownloadPdf = () => {
        setLoadingg(true);
        const url = base_url + 'generate-pdf';
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({"subject_id": subjDetails?.subject_id,"event_id":  eventDtls?.adverse_event_mapping_id }),
        })
          .then((response) => response.blob())
          
          .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `${studyName}_${subjectProfile?.subject_code}_${eventDtls?.study_aebank_event_title}${(eventDtls?.date_of_onset ? `(${eventDtls.date_of_onset})` : '')}_CIOMS_REPORT.pdf`
            );
            document.body.appendChild(link);
            link.click();
            setLoadingg(false);
          })
          .catch((error) => {
            console.error('Error generating PDF: ', error);
          });
             
      };


  return (
    <div>
      <NavigationBar
        studyDropdwn={currentPage === 1 ? false : true}
        title={"Adverse Events of Subjects"}
        rolecode={rolecode}
      />
      <div className="main_body ">
        {currentPage === 1 && (
          <Container
            fluid
            className="pt-3 pb-3 py-lg-2 py-md-2 py-xxl-4 mblbgclr"
          >
            <div className="">
              <Stack
                direction="horizontal"
                gap={3}
                className="p-0 pb-md-3 pb-lg-3 pb-xxl-3 add_subject_stack bg-white justify-content-between pe-2"
              >
                <div className=" d-flex justify-content-between justify-content-md-start gap-2 pilistfiltrs align-items-center">
                  <div>
                   
                    {

                      <select
                        value={siteSelected}
                        onChange={handleOptionSelectSite}
                        className="custom-select"
                        style={{ width: "auto" }}
                      >
                        <option value={"Sites"}>Sites</option>
                        {siteOptions?.map((option) => (
                          <option key={option.value} value={option.value} title={option.label}>
                            {option.label}
                          </option>
                        ))}
                      </select>

                    }
                  </div>
                  <div>
                    {
                      <Select
                        selectedOption={doseSelected}
                        selectdivstyl={""}
                        name={"classification"}
                        width={"auto"}
                        label={""}
                        options={doseOptions}
                        initialValue={"Doses"}
                        onChange={handleOptionSelectDose}
                      />
                    }
                  </div>
                  <div>
                    {
                      <Select
                        selectedOption={statusSelected}
                        selectdivstyl={""}
                        name={"classification"}
                        width={"100%"}
                        label={""}
                        options={statusOptions}
                        initialValue={"Status"}
                        onChange={handleOptionSelectStatus}
                      />
                    }
                  </div>
                  <div className="clr_btn_mdqr_two mt-1">
                    <button className="orange_btn" onClick={handleClearFilters}>
                      Clear
                    </button>
                  </div>
                  <div className="clr_btn_mdqr">
                    <button className="orange_btn" onClick={handleClearFilters}>
                      Clear
                    </button>
                  </div>
                </div>


       

                  
              </Stack>
              <div className="card_row">
                <Row className="d-flex pb-2 justify-content-between">
                  {dashboardCards?.map((card, index) => {
                    return (
                      <Col
                        key={index}
                        xs={6}
                        md={3}
                        className={`pb-md-0 pe-0 card_row C-pointer ${
                          index === 0 || index === 1 ||index===2 ? "pe-2 pb-1" : ""
                        }`}                       
                          style={{ maxWidth:"300px"}}
                      >
                        <div
                          className="card-container shadow"
                          style={{ backgroundColor: card.bgcolor, outline: selectedOption === card.id ? "2px solid black" :"" }}
                          onClick={() => handleRadioChange(card.id)}
                           
                        >
                          <div className="content">
                            <span style={{ color: card.color }}>
                              {card.count}
                            </span>
                            <img src={card.image} alt="" />
                          </div>
                          <div
                            className="desc"
                            style={{ color: card.descolor }}
                          >
                            {card.desc}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
            {subjectList && subjectList.length > 0 ? (
              <Container fluid className="pitable_container p-0" >
                <Row className="searchbar" >
                  <Col className="searchFiled gap-2 gap-md-3">
                    <input
                      type="search"
                      value={searchText}
                      placeholder={"Search with Subject ID"}
                      onChange={handleSearchData}
                    />
                    <div className=" ">
                      <button
                        className="btn btn-success"
                        onClick={exportToExcel}
                        style={{height:"42px"}}
                      >
                        <span className="fa-download-icon">
                          <i className="fa-solid fa-download" />
                        </span>
                        <span className="dwld_txt">Download XLS</span>
                        <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                      </button>
                    </div>
                  </Col>
                </Row>

                <div>
                  {loading_flag ? (
                    <div className="">
                      <img
                        className="atrium_loader"
                        src="/images/circle-effect-loading.gif"
                        alt="Loader"
                      />
                    </div>
                  ) : (
                    <div className="table-scroll-container " style={{border:"1px solid #E1E5E7 "}}>
                      {filteredData?.length > 0 ? (
                        <Table
                          bordered
                          size="sm"
                          className="pitable pisubjlistmbl mb-0"
                        >
                          <thead className="sticky_table_header">
                            <tr>
                              <th> S.No</th>
                              <th className="sticky-header">
                              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                        </th>

                              <th>
                                Last Updated
                              </th>
                              <th style={{ minWidth: "90px" }}>
                                Initials
                              </th>
                              <th style={{ minWidth: "70px" }}>
                                Age
                              </th>
                              <th style={{ minWidth: "70px" }}>
                                Sex
                              </th>
                              <th style={{ minWidth: "70px" }}>
                                Dose
                              </th>
                              <th style={{ minWidth: "90px" }}>
                                Events
                              </th>
                              <th>
                                Status
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody className="tableBodyScroll">
                            {filteredData?.map((i, index) => {
                              switch (i.sex) {
                                case "Male":
                                  i.sex = "M";
                                  break;
                                case "Female":
                                  i.sex = "F";
                                  break;
                                case "Others":
                                  i.sex = "O";
                                  break;
                                default:
                                  break;
                              }
                              const numbersArray = i.subject_code
                                .split("/")
                                .filter((item) => item.trim() !== "");
                              let lastNumber = [];
                              if (numbersArray.length > 0) {
                                lastNumber =
                                  numbersArray[numbersArray.length - 1];
                              }
                              const formattedLastUpdated = formatDate(i.lastUpdated);
                              return (
                                <tr key={i.index} className="text_left_table">
                                  <td className="text_right_sno"> {index + 1} </td>
                                  <td>{lastNumber}</td>
                                  <td>{i.subject_code ? i.subject_code :"-"}</td>

                                  <td className="text-center">{formattedLastUpdated}</td>
                                  <td>{i.first_name ? i.first_name[0] + i.last_name[0]  :"-"}</td>
                                  <td>{i.age ? i.age :"-"} Yrs</td>
                                  <td>{i.sex ? i.sex :"-"} </td>
                                  <td>{i.dose ? i.dose :"-"}</td>
                                  <td>{i.events ? i.events :"-"}</td>
                                  <td style={{ color: getStatusTextColor(i.status) }}>{i.status ? i.status :"-"}</td>
                                  <td
                                    className=" mb-0 align-items-center viewbtnstylmbl"
                                    onClick={() => handleSubjectData(i)}
                                  >
                                    <div
                                      style={{
                                        marginLeft:
                                          i.status === "ON STUDY" &&
                                          window.screen.width <= 600
                                            ? "40px"
                                            : "0",
                                      }}
                                    >
                                      <article>{i.status ? i.status :"-"}</article>
                                    </div>
                                    <h3 className="mb-0">{">"}</h3>
                                  </td>
                                  <td className="viewbtnstyl">
                                    <button
                                      className="gray_btn px-3"
                                      onClick={() => handleSubjectData(i)}
                                    >
                                      View
                                    </button>{" "}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : (
                     
                        <div>
                          <Table bordered size="sm" className="pitable">
                            <thead>
                              <tr>
                                <th> S.No</th>
                                <th>
                                  Subject ID
                                </th>
                                <th>
                                  Last Updated
                                  
                                </th>
                                <th style={{ minWidth: "90px" }}>
                                  Initials
                                 
                                </th>
                                <th style={{ minWidth: "70px" }}>
                                  Age
                                  
                                </th>
                                <th style={{ minWidth: "70px" }}>
                                  Gender
                                 
                                </th>
                                <th style={{ minWidth: "70px" }}>
                                  Dose
                                 
                                </th>
                                <th style={{ minWidth: "90px" }}>
                                  Events
                                 
                                </th>
                                <th>
                                  Status
                                 
                                </th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  colSpan="20"
                                  className="bg-white border py-4 text-center"
                                >
                                  No records found
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Container>
            ) :  subjectList === null ? <div className=''>
                  <img
                      className="atrium_loader"
                      src="/images/circle-effect-loading.gif"
                      alt="Loader"

                  />
                </div> :  (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "5rem",
                  }}
                >
                  <img src="./images/no_subjects.svg" alt="Telephone" />
                  <h5>No Adverse Events Of Subjects Are Available</h5>
                </div>
              </>
            )}
          </Container>
        )}

        {loading_flag ? <div className=''>
                            <img
                                className="atrium_loader"
                                src="/images/circle-effect-loading.gif"
                                alt="Loader"
                            />
                        </div> :(currentPage === 2 && subjectProfile && modifiedData) && (
          <Container fluid className="pt-2 page_two_styl" >
            <Row className="d-flex justify-content-between">
              <Col className="ps-0">
                <button className="white_btn white_btn_back py-2" onClick={handlePageandStudy}>
                  {"< "}Back
                </button>{" "}
              </Col>
            
            </Row>
            <Container fluid className="pt-2 p-0">
              <Row className="SVdtl_Main" style={{maxHeight:"100vh", overflow:"auto"}}>
                <Col xs={12} lg={4} className="section_1">
                  <div className="pisubj_left_main">
                    <div className="title_cls title_clsmbl">
                      <h5>Subject Profile</h5>
                    </div>
                    <div className="left_content_subjlist">
                      <div className="body_cls gap-2 pb-2">
                        <span>
                          <h6>Subject Code: {subjectProfile?.subject_code}</h6></span>
                          
                                                                                                                <div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-12 p-0">
        <div className="mb-0">
            <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
        </div>
    </div>

                                        </div>   
                        <span className="d-flex justify-content-between w-100">
                          <h6 className="site_add">
                            {subjectProfile["Site.site_name"]}{" "}
                          </h6>
                          <img
                            className=""
                            src="./images/icons/location.svg"
                            alt="Location Icon"
                          />
                        </span>
                      </div>
                      <div className="px-3 s2 studydtlsmbl">
                        {myArray.map((i, index) => {
                          return (
                            <div
                              className={`${
                                window.screen.width <= 600
                                  ? "studytabmbl"
                                  : "studytab"
                              }`}
                              key={index}
                            >
                              <span className="text-start">{i.title}</span>
                              <span className="study_tab_desc">
                                {i.description}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className=" pisub">
                  <div className="title_cls right_cntnt right_cntntmbl">
                    <h5 className="title">Adverse Events</h5>
                  </div>
                  <div className=" px-5 pt-5 right_content_stepper">
                    <div className="text-left ">
                      <Stepper
                        events={modifiedData}
                        handleAE={(id) => handleAE(id)}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Container>
        )}

        {currentPage === 3 && (
          <Container fluid className="px-0 page_two_styl">
            <Row className="SVdtl_Main">
              <Col lg={4} className="section_1">
                {subjDetails && (
                  <div className="pisubj_left_main">
                    <div className="review_min_high">
                      <div className="body_cls pb-2">
                        <span>
                          <h6 className="mt-3">{subjDetails?.subject_code}</h6></span>                                                                                                           <div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-12 p-0">
        <div className="mb-0">
            <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
        </div>
    </div>

                                        </div> 

                        <span className="d-flex justify-content-between w-100">
                          <h6 className="site_add">
                            {subjDetails["Site.site_address"]}
                          </h6>
                          <img
                            className=""
                            src="./images/icons/location.svg"
                            alt="Location Icon"
                          />
                        </span>
                      </div>
                      <div className="px-3 s2">
                        {myArray.map((i, index) => {
                          return (
                            <div className="studytab" key={index}>
                              <span className="text-start">{i.title}</span>
                              <span className="study_tab_desc">
                                {i.description}
                              </span>
                            </div>
                          );
                        })}
                      </div>

                      <div className="px-3 s2">
                        {reviewerComments &&
                          reviewerComments?.filter(
                            (i) => i.user_persona === QUALITY_REVIEWER
                          ).length > 0 && (
                            <div className="studytab">
                              <span className="text-start">
                                Quality Reviewer Comments
                              </span>
                              {reviewerComments &&
                                reviewerComments
                                  ?.filter(
                                    (i) => i.user_persona === QUALITY_REVIEWER
                                  )
                                  .map((i, index) => {
                                    return (
                                      <div key={index}>
                                        <div className="qr_cmts_txt d-flex flex-row">
                                          <li></li>
                                          <div>{i.comment}</div>
                                        </div>
                                        <span className="qr_cmts_date ">
                                          By : {i.created_by} {", "} On :{" "}
                                          {moment(i.createdAt).format(
                                            "DD/MM/YYYY HH:mm:ss"
                                          )}
                                        </span>
                                      </div>
                                    );
                                  })}
                            </div>
                          )}

                        {reviewerComments &&
                          reviewerComments?.filter(
                            (i) => i.user_persona === MEDICAL_REVIEWER
                          ).length > 0 && (
                            <div className="studytab">
                              <span className="text-start">
                                Medical Reviewer Comments
                              </span>
                              {reviewerComments &&
                                reviewerComments
                                  ?.filter(
                                    (i) => i.user_persona === MEDICAL_REVIEWER
                                  )
                                  .map((i, index) => {
                                    return (
                                      <div key={index}>
                                        <div className="qr_cmts_txt d-flex flex-row">
                                          <li></li>
                                          <div>{i.comment}</div>
                                        </div>
                                        <span className="qr_cmts_date ">
                                          By : {i.created_by} {", "} On :{" "}
                                          {moment(i.createdAt).format(
                                            "DD/MM/YYYY HH:mm:ss"
                                          )}
                                        </span>
                                      </div>
                                    );
                                  })}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                )}
              </Col>
              {loading && <Loader />}
              <div className="col review_event_header pisub">
                <div className="title_cls right_cntnt">
                  <h5 className="mb-1">Event</h5>
                  {/* <span >1 of 2</span> */}
                  {eventDtls?.qr_event_status == EVENT_STATUS_REVIEWED && eventDtls?.mr_event_status === EVENT_STATUS_REVIEWED ? (
                    <span style={{ marginLeft: "5px" }}>
                      <span>Download CIOMS Report</span>
                      <img
                        src="./images/icons/reshot-icon-pdf.svg"  // Replace with the actual path to your PDF icon
                        alt="PDF Icon"
                        onClick={handleDownloadPdf}
                        style={{ cursor: "pointer", width: "40px", height: "35px", marginRight: "10px" }}
                      />
                    </span>
                    
                  ) : (
                    null
                  )}
               
                </div>

                <Col className="px-4 py-3 qr_right_content">
                  <div className="d-flex justify-content-between ">
                    <div className="">
                      <label htmlFor="dateOfonSet" className="custm_label_fw">
                        Date of onset
                      </label>
                      <input
                        value={eventDtls?.date_of_onset}
                        className="customInput"
                        id="dateOfonSet"
                        type="date"
                        placeholder="Enter Here"
                        disabled
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "340px",
                          cursor: "not-allowed",
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="">
                      <label htmlFor="timeOfonSet" className="custm_label_fw">
                        Time of onset (24 Hrs)
                      </label>
                      <input
                        value={eventDtls?.time_of_onset}
                        className="customInput"
                        disabled
                        id="timeOfonSet"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <div className="">
                      <label
                        htmlFor="dateOfResolution"
                        className="custm_label_fw"
                      >
                        Date of resolution
                      </label>
                      <input
                        value={eventDtls?.date_of_resolution}
                        // value={moment(eventDtls?.date_of_resolution).format("DD-MM-YYYY")}
                        disabled
                        className="customInput"
                        id="dateOfResolution"
                        // min={minDate}
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "340px",
                          cursor: "not-allowed",
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs)
                      </label>
                      <input
                        value={eventDtls?.time_of_resolution}
                        disabled
                        className="customInput"
                        id="lastName"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                  </div>

                  <div htmlFor="lastName" className="custm_label_fw">
                    Past Health History
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <label htmlFor="lastName" className="">
                        Allergies
                      </label>
                      <input
                        value={eventDtls?.allergies ? eventDtls.allergies : "-"}
                        disabled
                        className="customInput"
                        id="lastName"
                        type="text"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                        <div>
                      <label htmlFor="medical_history" className="">
                        Medical history
                      </label>
                      <input
                        value={
                          eventDtls?.medical_history
                            ? eventDtls.medical_history
                            : "-"
                        }
                        disabled
                        className="customInput"
                        id="medical_history"
                        type="text"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div>
                      <label htmlFor="lastName" className="">
                        Concurrent Illness
                      </label>
                      <input
                        value={
                          eventDtls?.concurrent_illness
                            ? eventDtls.concurrent_illness
                            : "-"
                        }
                        disabled
                        className="customInput"
                        id="lastName"
                        type="text"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>                   
                  </div>

                  {eventDtls?.serious_adverse_event_name && (
                    <Row className="d-flex align-items-center">
                      <Col>
                        <label htmlFor="lastName" className="custm_label_fw">
                          Serious adverse event criteria
                        </label>
                      </Col>
                      <Col>
                        <span>
                          <button className="red_btn advesre-serious" >
                            {" "}
                            {eventDtls?.serious_adverse_event_name}
                          </button>
                        </span>
                      </Col>
                    </Row>
                  )}
                  {eventDtls?.study_aebank_event_title !== null && (
                    <Row className="d-flex align-items-center">
                      <Col>
                        <label htmlFor="lastName" className="custm_label_fw">
                          Adverse event
                        </label>
                      </Col>
                      <Col>
                        <span>
                          <button className="orange_btn advesre-serious" >
                            {" "}
                            {eventDtls?.study_aebank_event_title}
                          </button>
                        </span>
                      </Col>
                    </Row>
                  )}
                  <div className="advEventGroup">
                    <div className="p-4 bg-light rounded eventClassificationDiv">
                      <div className="custm-radio-styl reviewlist">
                        <div className="reviewaetilte">
                          <label
                            htmlFor="notmetcase"
                            style={{
                              display: "flex",
                              alignItems: "start",
                            }}
                          >
                            <input
                              type="radio"
                              id="notmetcase"
                              checked
                              style={{ width: "20px" }}
                            />
                            <span style={{ marginLeft: "10px" }}>
                              <div className="custm-radio-styl ">
                                {eventDtls?.study_event_meets_case_definition !==
                                null
                                  ? "Event meet case definition"
                                  : eventDtls?.study_event_doesnt_meets_case_definition !==
                                    null
                                  ? "Event does not meet case definition"
                                  : eventDtls?.study_ctcae_definition !== null
                                  ? "Grade"
                                  : eventDtls?.study_aebank_event_title &&
                                    eventDtls?.study_case_definition ==
                                      EVENT_CLASSIFICATION_AESI
                                  ? "Adverse Event of Special Interest"
                                  : "Other"}
                              </div>
                            </span>
                          </label>
                        </div>

                        <div className="subtext">
                          <img src="./images/icons/checkedbox.svg" alt="" />
                          {/* <span>{cleanText}</span> */}
                          <span>{cleanText && cleanText.charAt(0).toUpperCase() + cleanText.slice(1)}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={` gap-2 border p-3 rounded`}>
                    <div className="d-flex flex-column gap-3">
                      <div className={`d-flex ${JustBtwn}`}>
                        <div className="">
                          <label htmlFor="causality">Causality</label>
                          <input
                            value={eventDtls?.causality_name}
                            disabled
                            className="customInput"
                            id="lastName"
                            type="text"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                          />
                        </div>
                        <div className="">
                          <label htmlFor="outCome">Outcome</label>
                          <input
                            value={eventDtls?.outcome_name}
                            disabled
                            className="customInput"
                            id="lastName"
                            type="text"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                          />
                        </div>
                      </div>
                      <div className={`d-flex ${JustBtwn}`}>
                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine
                          </label>
                          <input
                            value={eventDtls?.action_taken_name}
                            disabled
                            className="customInput"
                            id="lastName"
                            type="text"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                          />
                        </div>
                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken For Adverse Event 
                          </label>
                          <input
                            value={
                              eventDtls?.action_taken_for_adverse_event_name
                            }
                            disabled
                            className="customInput"
                            id="lastName"
                            type="text"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                          />
                        </div>
                      </div>
                    
                    <div className="d-flex justify-content-between ">
                          {flag && (
                            <div className="start-end-date">
                              <label htmlFor="startDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment Start Date</p>
                              </label>
                              <input
                                value={eventDtls?.start_date_of_treatment}
                                className="custminputbml selectTag"
                                id="start_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter Start Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                          {/* End Date input */}
                          {flag && (
                            <div className="start-end-date">
                              <label htmlFor="endDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment End Date</p>
                              </label>
                              <input
                                value={eventDtls?.end_date_of_treatment}
                                className="custminputbml selectTag"
                                id="end_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter End Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                        </div>
                  </div>
                  </div>

                  {reviewerComments &&
                    reviewerComments?.filter(
                      (i) => i.user_persona === PRINCIPAL_INVESTIGATOR
                    ).length > 0 && (
                      <div>
                        <label htmlFor="Treatment" className="fw-bold fs-6">
                          Treatment Given
                        </label>
                        <div className="border py-3 px-2 rounded w-100">
                          {reviewerComments &&
                            reviewerComments?.map((i, index) => {
                              return i.user_persona ===
                                PRINCIPAL_INVESTIGATOR ? (
                                <div className="d-flexflex-column">
                                  <div className="d-flex">
                                    <li></li>
                                    <div>{i.comment.charAt(0).toUpperCase() + i.comment.slice(1)}</div>
                                  </div>
                                  <p className=" updateae_cmnt_date">
                                    Treated On:{" "}
                                    {moment(i.createdAt).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )}
                                  </p>
                                </div>
                              ) : (
                                ""
                              );
                            })}
                        </div>
                      </div>
                    )}

                
                                                   <div>
  {/* <label htmlFor="attachment" className="fw-bold fs-6">
    Attachments
  </label>
  {eventDtls?.documents?.length > 0 ? (
    <div style={{ width: "340px" }}>
      {eventDtls?.documents?.map((document) => {
        const fileExtension = (document.document_name || '').split('.').pop().toLowerCase();
        let icon = getIcon(fileExtension);
        extensions = fileExtension;

        return (
          <div key={document.document_id} className="card my-custom-class">
            <div className="d-flex flex-row justify-content-between">
              <p className="col-10" title={document.document_name ? document.document_name : ''}>
                {document.document_name
                  ? document.document_name.length > 30
                    ? `${document.document_name.slice(0, 30)}...`
                    : document.document_name
                  : ''}
              </p>
              <img
  height="30px"
  width="50px"
  src={icon}
  alt=""
  onClick={() => {
    if (['xlsx', 'xls'].includes(extensions)) {
      window.open(document.document_url, '_blank');
    } else {
      handleViewClick(document);
    }
  }}
  style={{ cursor: "pointer" }}
/>

            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <p>No documents found</p>
  )} */}
  {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
    <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isImage(extensions) ? (
          <img
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc', width: "100%" }}
          />
        ) : (
          <iframe
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc' }}
          />
        )}
      </Modal.Body>
    </Modal>
  )}
</div>

                              {inputValue?.meddra_llt_master_id !==null&&        
                  <div className="card review_card_bg p-3">
                        
                           
                    <div className="row justify-content-start">
                      <div className="col-4 ">
                        <label
                          htmlFor="lastName"
                          className="custm_label_fw"                          
                        >
                          MedDRA Classification
                        
                        </label>
                      </div>
                     
                       {inputValue?.meddra_llt_master_id !==null&& 
                        <MeddraForm object={inputValue}  />
                        }
                    </div>
                    <div className="version_txt pb-2 px-3">Version 26.1</div>
                  </div>}

                  {medicationDetails?.map((input, index) => {
                    const uniqueGenericNames = [
                      ...new Set(
                        whoddList?.map((item) =>
                          item.generic_name.toLowerCase()
                        )
                      ),
                    ];
                    const concatNames = [
                      ...uniqueGenericNames,
                      ...new Set(
                        whoddList?.map((item) =>
                          item.product_name.toLowerCase()
                        )
                      ),
                    ];

                   
                    return (
                      
                      <div>
                        { (eventDtls?.whoddDrugs?.length>0 && whoDDClassification && whoDDClassification?.length > 0)? (
                          <div className="card review_card_bg p-3">
                            
                    
                            <div className="row" key={input.id}>
                              <div className="col-4">
                                <label
                                  htmlFor="lastName"
                                  className="custm_label_fw"
                                  style={{ marginLeft: "15px" }}
                                >
                                  WHODD Classification
                                </label>
                              </div>
                    

                              {whoDDClassification &&
                                    whoDDClassification?.map((inputValue1, index) => (
                                      <div
                                        key={index}
                                        className="card my-3 ml-2  review_inner_card_bg_white_whodd"
                                        style={{ width:"96%",margin:"auto"}}
                                      >
                                        <div className="card-body" >
                                          <WhoDDForm value={inputValue1}/>
                                        </div>
                                      </div>
                                    ))}
                                    {window.location.pathname!=='/qrsubjectreview' && <div className="version_txt pb-2">Version GLOBALC3Sep23</div>}
                            </div>

                          </div>
                        ) : null}
                      </div>
                    );
                    
                  })}

                  <div className={JustBtwn}>
                    {subjData.status !== EVENT_STATUS_REVIEWED && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "20px",
                          width: "100%",
                          alignItems: "start",
                        }}
                      ></div>
                    )}
                  </div>
                </Col>
              </div>

              <div className="registrationStepsFooter">
                <button
                  className="white_btn white_btn_back px-3"
                  onClick={() => {
                    setCurrentPage(2);
                    //   window.location.reload()
                  }}
                >
                  Back
                </button>
              </div>
            </Row>
          </Container>
        )}
      </div>
    </div>
  );
};

export default PISubjectsList;

const Stepper1 = ({ events, handleAE }) => {
  return (
    <Row className="">
      <Col className="vertical_stepper_main col-3">
        {events?.map((i, index) => {
          let formattedStringg = i.day?.replace(/(\D)(\d+)/, '$1 $2');
          return (
            <div className="vertical_stepper_section" key={index}>
              <Col className="dataleft">
                <div className="fs-6">{formattedStringg}</div>
                <div className="date">
                  {moment(i.dateOfevent).format("DD-MM-YYYY")}
                </div>
              </Col>
            </div>
          );
        })}
      </Col>
      <Col className="vertical_stepper_main">
        <div className="vertical_stepper_dots  ">
          {events?.map((i, index) => {
            let yellowDot;
            let seriousDot;
            i.eventClassification?.map((i) => {
              yellowDot = i.adverse_events?.length !== 0;
            });
            i.eventClassification?.map((i) => {
              seriousDot = i.serious_adverse_events?.length !== 0;
            });

            {
              /* let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events')) */
            }
            {
              /* let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events')) */
            }
            return (
              <div className="vertical_stepper_section" key={index}>
                <Col
                  className={`dot ${
                    seriousDot && yellowDot
                      ? "C-red"
                      : seriousDot && !yellowDot
                      ? "C-red"
                      : !seriousDot && yellowDot
                      ? "C-orange"
                      : "C-gray"
                  }`}
                />

                <div>
                  {i.eventClassification?.map((i, index) => {
                    return (
                      <div key={index} className="">
                        <div className="">
                          <div className="adveventstyl">
                            {i.adverse_events?.map((item, index) => (
                              <div
                                key={item.adverse_event_mapping_id}
                                className="clickable-string serious-adverse-event"
                                onClick={() =>
                                  handleAE(item.adverse_event_mapping_id, true)
                                }
                              >
                                {item.study_aebank_event_title}
                                {index !== i.adverse_events?.length - 1
                                  ? ","
                                  : ""}
                              </div>
                            ))}
                          </div>
                          <div className="adveventstyl">
                            {i.serious_adverse_events?.map((item, index) => (
                              <div key={item.adverse_event_mapping_id}>
                                {item.serious_adverse_event_name}
                                {index !== i.serious_adverse_events?.length - 1
                                  ? ","
                                  : ""}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Col>

      {/* <Col className='vertical_stepper_main '>
                {events?.map((i, index) => {
                    let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events'))
                    let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events'))
                    return (
                        <div className='' key={index}>


                            <Col className=''>{i.eventClassification?.map((i, index) => {
                                return <div key={index}>
                                    {i.adverse_events}{i.serious_adverse_events}


                                </div>
                            })}</Col>
                        </div>
                    )
                })}
            </Col> */}
    </Row>
  );
};

const Stepper = ({ events, handleAE }) => {
  return <>
    <div className='mb-3 dor_note'>{"("}<span className='text-danger'>*</span>{")"} - The date of resolution has not been added to the events.</div>
    { events?.map((i, index) => {
            let yellowDot
            let seriousDot
            let greenDot = i?.eventClassification && i?.eventClassification[0]?.adverse_events[0]?.isEventEnd || i?.eventClassification && i?.eventClassification[0]?.serious_adverse_events[0]?.isEventEnd
            let greenOrange = ((i?.eventClassification && i?.eventClassification[0]?.ongoingAdverseEvents >= 1) || (i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1)) && i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1
            let saeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && (i?.eventClassification && i?.eventClassification[0]?.startedSeriousAdverseEvents >= 1 || i?.eventClassification && i?.eventClassification[0]?.ongoingSeriousAdverseEvents >= 1)
            let aeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1
           
            i.eventClassification != null && i.eventClassification?.map(i => {
                yellowDot = (i.adverse_events?.length !== 0)
            })
            i.eventClassification != null && i.eventClassification?.map(i => {
                seriousDot = i.serious_adverse_events?.length !== 0
            })
            let formattedStringg = i.day?.replace(/(\D)(\d+)/, '$1 $2');
            return (
                <Row className='stprmainmbl' >
                    <div className='vertical_stepper_main col-5 col-md-3 col-lg-3 col-xxl-3'>
                        <div className='vertical_stepper_section' key={index}>
                            <Col className='dataleft'>
                                <div className=' fw-bold'>{formattedStringg}</div>
                                <div className='date'>{moment(i.dateOfevent).format("DD-MM-YYYY")}</div>
                            </Col>
                        </div>
                    </div>
                    <div className='vertical_stepper_main col'>
                        <div className={`vertical_stepper_dots ${events.length-1 == index ? "border-0" : ""}`}>
                            <div className='vertical_stepper_section' key={index}>
                                <Col className={`${(greenOrange || saeStartEnd) ? "dot-green-inside": "dot"} ${aeStartEnd && "outer-orange"}  ${saeStartEnd ? "outer-red" :greenOrange ? "outer-orange" : greenDot ? "C-green" : seriousDot ? "C-red" : !seriousDot && yellowDot ? "C-orange" : "C-gray"}`} />

                                {i.eventClassification!=null && i.eventClassification?.map((i, index) => {
                                    const startEvents = i.adverse_events.filter((each) => each.isEventStart)
                                    const endEvents = i.adverse_events.filter((each) => each.isEventEnd)
                                    const ongoingAE = i.adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const ongoingSAE = i.serious_adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const startSaEvents = i.serious_adverse_events.filter((each) => each.isEventStart)
                                    const endSaEvents = i.serious_adverse_events.filter((each) => each.isEventEnd)
                                    const noOfEvents = startEvents.length+endEvents.length+ongoingAE.length+ongoingSAE.length+startSaEvents.length+endSaEvents.length
                                    return (
                                        <div key={index} className={`aestylmbl ${noOfEvents >= 3 && "pb-4"}`} >
                                            <div className='adveventstyl'>
                                                {ongoingAE.length > 0 && <div className="d-flex flex-wrap">
                                                {ongoingAE.length > 0 && ongoingAE.map((each,index) => {
                                                    return  <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {each.study_aebank_event_title}
                                                    {index === ongoingAE?.length - 1 ? (ongoingAE?.length === 1 && startEvents?.length === 0 && endEvents?.length === 0) ? "" :  '.' : ','}
                                                </div>
                                                })}
                                                </div>}
                                                {startEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {startEvents.length > 0 && startEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "Start: ": "" }{each.study_aebank_event_title}{each.isDateOfResolutionGiven === false && <span className='text-danger'>*</span> }</span>}
                                                    {index === startEvents?.length - 1 ? (startEvents?.length === 1 && endEvents?.length === 0) ? "" : '.' : ','}
                                                </div>
                                                })}</div>}
                                                {endEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {endEvents.length > 0 && endEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ?"End: " : ""}{each.study_aebank_event_title}</span>}
                                                    {index === endEvents?.length - 1 ? (endEvents?.length === 1) ? "" : '.' : ','}
                                                </div>
                                                } )}</div>}
                                            </div>

                                            <div className='adveventstyl'>
                                              {ongoingSAE.length > 0 && <div className="d-flex flex-wrap">
                                                {ongoingSAE.length > 0 && ongoingSAE.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    <span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span>
                                                    {index === ongoingSAE.length-1 ? (ongoingSAE?.length === 1 && startSaEvents?.length === 0 && endSaEvents?.length === 0) ? "" :  '.'  : ','}
                                                </div>
                                                })}</div>}
                                              {startSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {startSaEvents.length > 0 && startSaEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "Start: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                    {index === startSaEvents?.length - 1 ? (startSaEvents?.length === 1 && endSaEvents?.length === 0) ? "" : '.' : ','}
                                                </div> 
                                                })}</div>}
                                                {endSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {endSaEvents.length > 0 && endSaEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "End: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                    {index === endSaEvents?.length - 1 ?(endSaEvents?.length === 1) ? "" : '.' : ','}
                                                </div>
                                                })}</div>}
                                            </div>

                                        </div>)
                                })}
                            </div>
                        </div>
                    </div>
                </Row>
            )})}
    </>
};
